import type {FileItem} from '../QuestionnaireAttachment'
import type {FormState} from 'components/Embed/EmbedQuestionnaire'

const formStatePrefix = 'questionnaire-'

const getAnswerName = (name: string, readableName?: string) => readableName || (name.startsWith(formStatePrefix) ? name.slice(formStatePrefix.length) : name)

export const prepareMetadata = (formState: FormState) => {
    // eslint-disable-next-line no-undef-init
    let ratingToSend: string | number | boolean | FileItem[] | undefined = undefined

    const metadataToSend = Object.entries(formState).reduce((answers, [name, answer]) => {
        if (answer._isAudienceMetadata) {
            return answers
        }

        // eslint-disable-next-line no-extra-parens
        const valueToSend = (answer.value !== false && answer.value !== undefined) ? answer.value : '-'
        const answerName = getAnswerName(name, answer.readableName)

        if (name === 'questionnaire-rating') {
            ratingToSend = valueToSend
        } else if (answer.type === 'checkbox') {
            if (answer.readableName && answer.value === false) {
                answers[answerName] = false
            } else if (answer.value === true) {
                answers[answerName] = answer.value
            }
        } else if (answer.type !== 'attachment') {
            answers[answerName] = valueToSend
        }

        return answers
    }, {} as Record<string, string | boolean | object | number>)

    return {
        metadataToSend,
        ratingToSend,
    }
}
